<template>
  <div class="home">
    <header-view curr="3"></header-view>
    <div class="body">
      <!-- <div class="boxtitle">
        <titleview title="公示公告" color="#E61F26" class="left"></titleview>
      </div> -->
	  <div class="toptitle">
	  		<div class="left_c">
				<div class="redcon"></div>
				<span>公示公告</span>
			</div>
			<div class="right_c">
				<div class="searchcon">
					 <input class="inputa" v-model="searchv" @input="changeinput" placeholder="请输入"/>
					 <img class="imgcon" src="../assets/searchimg.png" alt="" 
					 @click="changeinput"/>
				</div>
			</div>
	  </div>
	  
      <div class="centent">
        <div v-for="(item, index) in list">
          <!-- <router-link :to="'/noticeDetails?index=' + index + '&id=' + item.id"> -->
		  <div @click="toDatail(index,item)">
            <div class="item hand">
              <div class="title " :title="item.titile">{{ item.titile }}</div>
              <div class="subtitle">
                <div class="left">
					<span style="margin-right: 1rem;font-size: 0.14rem;">作者：{{ item.createBy_dictText || ''}}</span>
					<!-- <span>阅读：{{ item.views || '0'}}次</span> -->
				</div>
                <div class="right" style="font-size: 0.12rem;">{{ item.sendTime }}</div>
              </div>
            </div>
		  </div>
          <!-- </router-link> -->
        </div>
      </div>
      <zhini-pagination
        class="zhini-pagination"
        :currentPage="pageNo"
        :totalPage="totalPage"
        @pageNum="pageNum"
      ></zhini-pagination>
    </div>
  </div>
</template>

<script>
import zhiniPagination from "../components/zhini-pagination.vue";
export default {
  name: "notice",
  components: {
    zhiniPagination
  },
  data: function() {
    return {
      list: "",
      pageNo: 1,
      pageSize: 8,
      totalPage: 0,
      url: "",
	  
	  typesign:0,
	  searchv:"",
    };
  },
  created() {	  
    this.init();	
  },
  watch:{
  		$route(){
  		      this.typesign = this.$route.query.type
  		},
  	    typesign() {
  	      	this.typesign = this.$route.query.type
  			this.init()
  	    },
  },
  methods: {
	//搜索
	changeinput(){
		this.init();
	},
	
    toDatail(indexsign,item){
		this.$router.push({ path: '/noticeDetails', query: {index:indexsign,id:item.id} });
	},
 
    init() {
      var that = this;
	  var val = "sendTime"
	  if(this.$route.query.type == 2){
		  val = "views"
	  }
      this.httpGet("web/annountCement/webList", {
			sort:val,
			pageNo: this.pageNo,
			pageSize: this.pageSize,
			titile:this.searchv
      }).then(res => {
			that.list = res.result.records;
			that.totalPage = Math.ceil(res.result.total / that.pageSize);
      });
    },
    pageNum(e) {
	  window.pageYOffset = 0;
	  document.documentElement.scrollTop = 0;
	  document.body.scrollTop = 0;	
		
      this.pageNo = e;
      this.init();
    }
  },
  mounted() {}
};
</script>
<style scoped="scoped" lang="scss">
// ::-webkit-scrollbar {
//             width: 0px;
//         }
.home {
  // background: #f4f5f9;
  width: 100%;
  min-height: 11rem;
  overflow: hidden;
  position: relative;
  .body {
    width: 11.52rem;
    min-height: 11rem;
	// height: 100%;
    background: #ffffff;
    margin: 2.22rem auto 0;
    padding: 0 0.7rem;
    overflow: hidden;
    .centent {
      width: 10.22rem;
      margin: 0 auto;
      // min-height: 5rem;
      // height:5rem;
      // overflow:auto;
      .item {
        border-bottom: 0.01rem dotted #e0e0e0;
        // height: 0.59rem;
        overflow: hidden;
        .title {
          font-size: 0.18rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          margin-top: 0.24rem;
          margin-bottom: 0.1rem;
        }

        .subtitle {
          font-size: 0.18rem;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #999999;
          margin-bottom: 0.22rem;
          overflow: hidden;
        }
      }
      .item:hover {
        .title {
          color: rgba(230, 31, 38, 1);
        }
      }
    }
    .zhini-pagination {
      position: absolute;
      bottom: 0.55rem;
      width: 100%;
      left: 0;
    }
	
	.toptitle{
		// margin-left: 0.4rem;
		// margin-right: 0.4rem;
		height: 0.6rem;
		border-bottom: 1px solid #ededed;
		display: flex;
		align-items: center;
		justify-content: space-between;
		.left_c{
			display: flex;
			align-items: center;
			.redcon{
				width: 0.05rem;
				height: 0.2rem;
				background: #E70012;
				margin-right: 0.2rem;
			}
			font-size: 0.18rem;
			font-weight: 400;
			color: #E61F26;
		}
		.right_c{
			// margin-right: 0.2rem;
			.searchcon{
				height: 0.4rem;
				line-height: 0.4rem;
				width: 2.68rem;
				background: #F1F1F1;
				border-radius: 0.15rem;
				padding-left: 0.2rem;
				padding-right: 0.2rem;
				display: flex;
				align-items: center;
				justify-content: space-between;
				.inputa{
					font-size: 0.14rem;
				}
				.imgcon{
					height:0.18rem;
					width: 0.18rem;
				}
			}
		}
	}
	
	// .boxtitle {
	//     width: 10.62rem;
	//     overflow: hidden;
	//     margin: 0.1rem 0 0.2rem -0.2rem;
	//     border-bottom: 0.01rem solid rgba(140, 140, 140, 0.24);
	// }
	
  }
}
</style>
